import axios from 'axios'
import { url } from '../../api/url'
import { HeadersWithCredentials } from '../../api/header'

export const getMyPartnerEvents = async () => {
    return await axios.get(`${url}/partners/my-events`, {
        headers: HeadersWithCredentials(),
    })
}
